// frontend/src/pages/PaymentHistory/usePayments.ts
// React Query hook for the payments list.

import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../utils/apiFetch";
import type { Payment } from "./types";

/**
 * Fetches all payments for the current org.
 * Cached for 60 seconds; does not refetch on window focus.
 */
export function usePayments() {
  return useQuery<Payment[]>({
    queryKey: ["payments-history"],
    queryFn: async function () {
      const res = await apiFetch("/api/v1/payments");
      if (!res.ok) throw new Error("Failed to load payments");
      return res.json();
    },
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
  });
}